import React, { useState, Fragment } from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate, useParams } from 'react-router-dom';
const courseNames: Record<string, string> = {
  '1': 'Ethics & The Rules (with NAR Code of Ethics)',
  '2': 'NAR Code of Ethics (NO CE CREDIT)',
  '3': 'Deeds, Fires & Water: Be Prepared',
  '5': 'Are They Represented?',
  '6': 'Mastering Agency Agreements',
  '8': 'A Letter From ADRE',
  '9': "Don't Lose Your License",
  '10': 'BMC #1 AZ Residential-Statutes and Rules',
  '11': 'BMC #2 AZ Residential-Broker Policies',
  '12': 'BMC #3 AZ Residential-Broker Supervision',
  '13': 'BMC #3B Property Management',
  '14': 'What Goes Wrong In Contracts',
  '15': 'Avoid The Oops: Contract Smarts for Agents',
  '17': 'No Secrets',
  '18': 'The Bottom Line of Disclosure',
  '19': 'Your Clients Are Not Mushrooms',
  '20': 'They Are A Protected Class',
  '21': "Fair Housing In Today's World",
  '23': 'Accidental Property Management',
  '24': 'Follow All The Laws'
};
export function CourseSectionsByCourse() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const courseName = courseNames[id ?? ''] ?? 'Course';
  const sections = [1, 2, 3, 4, 5].map(n => ({
    id: n,
    section: `Section ${n}`
  }));
  return <div className="space-y-4" data-id="element-381" data-mp="2ry7m19bsnaix">
      <div className="flex items-center justify-between" data-id="element-382" data-mp="2rz8yni8gk52r">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-383" data-mp="2nwmem3i13og4">Course Sections</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/courses')} data-id="element-384" data-mp="31v2hfjcrsusz">
          ← Back to Courses
        </Button>
      </div>

      <div data-id="element-385" data-mp="c6abkpsx93bb">
        <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/sections/add')} data-id="element-386" data-mp="c6js7ms2ty4c">
          <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-387" data-mp="o6i5cyzm2juq" />
          Add
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-388" data-mp="t87e27zd2lfn">
        <div className="overflow-x-auto" data-id="element-389" data-mp="y5fx0asc2thy">
          <table className="w-full text-sm text-left" data-id="element-390" data-mp="y44yapdqwbxp">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-391" data-mp="k1uvpnyh4hx">
              <tr data-id="element-392" data-mp="5haezvsnzilt">
                <th className="px-4 py-3 border-r border-slate-700" data-id="element-393" data-mp="5iv9jlezb1jo">Course</th>
                <th className="px-4 py-3 border-r border-slate-700 text-center w-28" data-id="element-394" data-mp="agenek7rlcb3">
                  Section
                </th>
                <th className="px-4 py-3 border-r border-slate-700 text-center w-32" data-id="element-395" data-mp="f8eser2oyvej">
                  Questions
                </th>
                <th className="px-4 py-3 text-center w-40" data-id="element-396" data-mp="3dvss4bxgpoca">
                  <div data-id="element-397" data-mp="3ivf5cldaj4l3">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-398" data-mp="3iudhfgb6enly">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-399" data-mp="36c1h16jiyj7x">
              {sections.map(row => <tr key={row.id} className="hover:bg-slate-50" data-id="element-400" data-mp="31gufo5dq9qm6">
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-401" data-mp="2wf532laux4vz">
                    <button className="text-blue-600 hover:underline text-left" onClick={() => navigate(`/courses/view/${id}`)} data-id="element-402" data-mp="2sel6biu743ad">
                      {courseName}
                    </button>
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-403" data-mp="2dpoztq7seybv">
                    <button className="text-blue-600 hover:underline" onClick={() => navigate(`/sections/view/${row.id}`)} data-id="element-404" data-mp="2dnm36nc4q6y6">
                      {row.section}
                    </button>
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-405" data-mp="2tg6i9r4ukv4b">
                    <button className="text-blue-600 hover:underline" onClick={() => navigate('/questions')} data-id="element-406" data-mp="2ydzpmnhvzv66">
                      View Questions
                    </button>
                  </td>
                  <td className="px-4 py-2.5 text-center" data-id="element-407" data-mp="2aodqu15ffhyp">
                    <div className="flex items-center justify-center gap-2" data-id="element-408" data-mp="2aqzuvqt3zfc6">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/sections/view/${row.id}`)} data-id="element-409" data-mp="2fpky7z3nqf4u">
                        <Eye className="h-4 w-4" data-id="element-410" data-mp="3w2j921onjhrd" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/sections/edit/${row.id}`)} data-id="element-411" data-mp="3w0f89sm1uyvb">
                        <Edit className="h-4 w-4" data-id="element-412" data-mp="1kfpjwngg1ca0" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-413" data-mp="1y6um9xb74io1">
                        <Trash2 className="h-4 w-4" data-id="element-414" data-mp="1tdrote3asp2k" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1" data-id="element-415" data-mp="2h5p0n56qzh3o">
        <button className="hover:underline" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} data-id="element-416" data-mp="2h2t3vk6myygt">
          &lt;&lt; previous
        </button>
        <span className="text-slate-400" data-id="element-417" data-mp="mrea8sai8evs">|</span>
        {[1, 2, 3].map((n, i) => <Fragment key={n} data-id="element-418" data-mp="htm8z7nyzgex" data-mpi={i}>
            {i > 0 && <span className="text-slate-400" data-id="element-419" data-mp="2huap77wf0412">|</span>}
            <button onClick={() => setCurrentPage(n)} className={`hover:underline ${currentPage === n ? 'text-slate-900 font-medium' : ''}`} data-id="element-420" data-mp="2hvm1jw3xek3s">
              {n}
            </button>
          </Fragment>)}
        <span className="text-slate-400" data-id="element-421" data-mp="2vttw5xdhp9bs">|</span>
        <button className="hover:underline" onClick={() => setCurrentPage(Math.min(3, currentPage + 1))} data-id="element-422" data-mp="2vvn4ri7ny3mf">
          next &gt;&gt;
        </button>
      </div>
    </div>;
}